


















import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

@Component
export default class TransferImageGallery extends Vue {
 selectedImageIndex: number = 0;
  dialog: boolean = false;
  images: any;


  data() {
    return {
      images: [
              { src: require("../images/transfer1.jpeg") },

      { src: require("../images/transfer17.jpeg") },
      { src: require("../images/transfer19.jpeg") },

                  { src: require("../images/transfer4.jpeg") },
            { src: require("../images/transfer23.jpeg") },
      { src: require("../images/transfer25.jpeg") },
      { src: require("../images/transfer18.jpeg") },
                  { src: require("../images/transfer11.jpeg") },

      { src: require("../images/transfer24.jpeg") },
      { src: require("../images/transfer3.jpeg") },
      { src: require("../images/transfer16.jpeg") },
      { src: require("../images/transfer15.jpeg") },
      { src: require("../images/transfer26.jpeg") },


      { src: require("../images/transfer21.jpeg") },
      { src: require("../images/transfer20.jpeg") },
      { src: require("../images/transfer28.jpeg") },
      { src: require("../images/transfer8.jpeg") },
      { src: require("../images/transfer7.jpeg") },
      { src: require("../images/transfer29.jpeg") },
      { src: require("../images/transfer10.jpeg") },
      { src: require("../images/transfer27.jpeg") },
      { src: require("../images/transfer30.jpeg") },
      { src: require("../images/transfer22.jpeg") },
      { src: require("../images/transfer12.jpeg") },
      { src: require("../images/transfer6.jpeg") },
      { src: require("../images/transfer14.jpeg") },
      { src: require("../images/transfer5.jpeg") },
            { src: require("../images/transfer13.jpeg") },



            { src: require("../images/transfer2.jpeg") },
                  { src: require("../images/transfer9.jpeg") },


      ],
       selectedImage: require('../images/transfer1.jpeg'),
    };
  }



openModal(index) {
    this.selectedImageIndex = index;
    this.dialog = true;
  }

  closeModal() {
    this.dialog = false;
  }
}
